/* @flow */

import * as React from 'react';

import styles from './Checkbox.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

type Props = {
  name: string,
  value?: string,
  checked?: boolean,
  text: string,
  icon?: React.Node,
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void,
  'aria-describedby'?: string,
};

const useStyles = createUseThemeStyles(styles);

const Checkbox = ({
  value,
  checked,
  name,
  text,
  icon,
  onChange,
  'aria-describedby': ariaDescribedby,
  ...rest
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();
  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <>
      <input
        {...rest}
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        value={value}
        onChange={onChange}
        aria-describedby={ariaDescribedby}
      />
      <label className={classes.label} htmlFor={name}>
        {icon && <span className={classes.icon}>{icon}</span>}
        {text}
      </label>
    </>
  );
};

export default React.memo<Props>(Checkbox);
